export default {"src":"/_next/static/media/bookImage.e21674ea.svg","height":373,"width":372,"blurWidth":0,"blurHeight":0};